import axiosInstance from '@/utils/axiosInstance.js'
import SERVICES from '@/utils/servicesUtil.js'

const support = (targetOrganizationId, body) => axiosInstance.post(`${SERVICES.NOTIFICATION_CONTACT}/${targetOrganizationId}/support`, body)

export default {
  support,
}
